<template>
  <div id="hub"></div>
</template>

<script>
import CrossStorage from "cross-storage";
import { getCurrentMainDomain } from "@/utils/domain";
let CrossStorageHub = CrossStorage.CrossStorageHub;
const endUrl = getCurrentMainDomain() // 获取当前地址栏后缀主域名地址
let resq = new RegExp(`.*\\w+.${endUrl}.*$`)
CrossStorageHub.init([
  { origin: /localhost/, allow: ["get", "set"] },
  { origin: /.*192.168.31.*?$/, allow: ["get", "set"] },
  { origin: /.*172.20.10.*?$/, allow: ["get", "set"] },
  { origin: /.*\w+.sshlqf.com.*$/, allow: ["get", "set"] },
  { origin: resq, allow: ["get", "set"] }
])
export default {
  name: "Hub"
}
</script>

<style scoped></style>
